import { render, staticRenderFns } from "./callingrecords.vue?vue&type=template&id=03d8f9ca&scoped=true"
import script from "./callingrecords.vue?vue&type=script&lang=js"
export * from "./callingrecords.vue?vue&type=script&lang=js"
import style0 from "./callingrecords.vue?vue&type=style&index=0&id=03d8f9ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8f9ca",
  null
  
)

export default component.exports